import React from 'react';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    size?: number;
};

const Rows03Icon = ({
    color = 'currentColor',
    size = 24,
    strokeWidth = 2,
    strokeLinecap = 'round',
    strokeLinejoin = 'round',
    ...props
}: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path
            stroke={color}
            strokeLinecap={strokeLinecap}
            strokeLinejoin={strokeLinejoin}
            strokeWidth={strokeWidth}
            d="M3 9h18M3 15h18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3"
        />
    </svg>
);
export { Rows03Icon };
